import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api phần user
export const createNewTask = (args = {}) => {
    return api.makeAuthRequest({
        url: `/task`,
        method: 'POST',
        data: args,
    })
}
export const getListTask = (page_number, page_size, deleted) => {
    return api.makeAuthRequest({
        url: `/task/admin?page_number=${page_number}&page_size=${page_size}&status=${deleted}`,
        method: 'GET',
    })
}
export const getTodoTaskAdmin = (page_number, page_size, deleted) => {
    return api.makeAuthRequest({
        url: `/task/admin/todo?page_number=${page_number}&page_size=${page_size}`,
        method: 'GET',
    })
}
export const getTodoTask = (uid, page_number, page_size) =>{
    return api.makeAuthRequest({
        url: `/task/user/${uid}/todo?page_number=${page_number}&page_size=${page_size}`,
        method: 'GET',
    })
}
export const getListTaskOfUser = (uid, page_number, page_size, deleted) => {
    return api.makeAuthRequest({
        url: `/task/user/${uid}?page_number=${page_number}&page_size=${page_size}&status=${deleted}`,
        method: 'GET',
    })
}
export const getListTaskStar = (page_number, page_size) => {
    return api.makeAuthRequest({
        url: `/task/star?page_number=${page_number}&page_size=${page_size}`,
        method: 'GET',
    })
}
export const updateTaskStatusAPI = (task_id, status) => {
    return api.makeAuthRequest({
        url: `/task/updatestatus?task_id=${task_id}&status=${status}`,
        method: 'PUT',
    })
}
export const getTaskByIdAPI = task_id => {
    return api.makeAuthRequest({
        url: `/task/${task_id}`,
        method: 'GET',
    })
}
export const updateTaskAPI = (task_id, body) => {
    return api.makeAuthRequest({
        url: `/task/${task_id}`,
        method: 'PUT',
        data: body,
    })
}
export const sendTaskAPI = task_id => {
    return api.makeAuthRequest({
        url: `/task/${task_id}/send`,
        method: 'POST',
    })
}
export const MakeStarForTask = task_id => {
    return api.makeAuthRequest({
        url: `/task/star/${task_id}`,
        method: 'POST',
    })
}
export const DeleteStarForTask = task_id => {
    return api.makeAuthRequest({
        url: `/task/star/${task_id}`,
        method: 'DELETE',
    })
}
export const getActivityTask = (tid, page_number, page_size) => {
    return api.makeAuthRequest({
        url: `/task/${tid}/activity?page_number=${page_number}&page_size=${page_size}`,
        method: 'GET',
    })
}
export const getRankingInTask = tid => {
    return api.makeAuthRequest({
        url: `/task/${tid}/ranking`,
        method: 'GET',
    })
}
export const getListTaskByHashTag = (page_number, page_size, hashtag) => {
    return api.makeAuthRequest({
        url:
            `/hashtag/list/task?page_number=${page_number}&page_size=${page_size}&hashtag=` +
            encodeURIComponent(hashtag),
        method: 'GET',
    })
}
export const getListTaskAboutTime = (
    page_number,
    page_size,
    begin_time,
    end_time
) => {
    return api.makeAuthRequest({
        url: `/task/abouttime?page_number=${page_number}&page_size=${page_size}&begin_time=${begin_time}&end_time=${end_time}`,
        method: 'GET',
    })
}
export const getListTaskMergeQuery = (page_number, page_size, body) => {
    return api.makeAuthRequest({
        url: `/task/mergequery?page_number=${page_number}&page_size=${page_size}`,
        method: 'POST',
        data: body,
    })
}
